import { render, staticRenderFns } from "./MediaComponent.vue?vue&type=template&id=1fa7e768&scoped=true&"
import script from "./MediaComponent.vue?vue&type=script&lang=js&"
export * from "./MediaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa7e768",
  null
  
)

export default component.exports